import { bl_dgmkt_project_hdr_RowClass } from '../../../dbschema/bl_dgmkt_project_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class DgMktProjectHeaderContainerModel extends BaseContainerModel {
  bl_dgmkt_project_hdr: bl_dgmkt_project_hdr_RowClass = new bl_dgmkt_project_hdr_RowClass();
}
